<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Height*:</h4>
            <input type="number" v-model="$parent.mediaProperty.configuration.height" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Width*:</h4>
            <input type="number" v-model="$parent.mediaProperty.configuration.width" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Show Controls?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.controls" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Autoplay Video?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.autoPlay" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Is the video public?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.public" @change="changePublic" :disabled="!$parent.mediaProperty.isActive"/>
        </div>

        <div class="formRow">
            <h4>Poster:</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.poster" @change="saveVideo('poster')" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4></h4>
            <UploadMediaPropertyModal openButtonText="Upload Poster Image"
                                        modalTitle="Upload Image"
                                        :fileKey="$parent.mediaProperty.configuration.poster"
                                        acceptFileTypes="image/*"
                                        :onFileUpload="getImageLink"
                                        :permission="$parent.mediaProperty.configuration.public ? 'public-read' : 'private'"></UploadMediaPropertyModal>
        </div>
        <div class="formRow" v-if="imageLink">
            <h4></h4>
            <div>
                <img :src="imageLink" :key="imageKey" style="max-height: 200px; max-width: 200px;"/>
                <div>Not to scale</div>
            </div>
        </div>
        <h4>
            Video Logging:   
            <button class="addRowButton" @click="addLoggingActivity" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i>Add Logging</button>
            <button class="addRowButton" v-if="$parent.mediaProperty.configuration.loggingActivities.length === 0" @click="addDefaultLogging" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i>Add Default Logging</button>
        </h4>
        <div v-if="$parent.mediaProperty.configuration.loggingActivities">
            <div class="loggingRow">
                <div class="loggingCell">% of video</div>
                <div class="loggingCell loggingCellSelect">Log Activity Type Code</div>
                <div class="loggingCell">&nbsp;</div>
            </div>
            <div class="loggingRow" v-for="(log, index) in $parent.mediaProperty.configuration.loggingActivities" :key="log.key">
                <div class="loggingCell">
                    <input type="number" v-model="log.percentage" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
                </div>
                <div class="loggingCell loggingCellSelect">
                    <select v-model="log.logActivityTypeCode" @change="saveVideo">
                        <option :value="lat.code" v-for="lat in logActivityTypes" :key="lat.id">{{lat.code}}</option>
                    </select>
                    <div class="logActivityTypeDescription" v-if="log.logActivityTypeCode">{{ getLogActivityTypeDescription(log.logActivityTypeCode) }}</div>
                </div>
                <div class="loggingCell">
                    <button class="deleteButton" @click="deleteLoggingActivity(index)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                </div>
            </div>
        </div>
        <h4>Video Sources:</h4>
        <div class="childObject" v-for="(source, index) in $parent.mediaProperty.configuration.sources" :key="source.key">
            <div class="sequenceButtons" v-if="$parent.mediaProperty.configuration.sources.length > 1">
                <div class="sequenceMinusButton" @click="sequenceMinus(source, $parent.mediaProperty.configuration.sources)">
                    <i class="fa-solid fa-angle-up"></i>
                </div>
                <div class="sequencePlusButton" @click="sequencePlus(source, $parent.mediaProperty.configuration.sources)">
                    <i class="fa-solid fa-angle-down"></i>
                </div>
            </div>
            <div class="formRow">
                <h4>Src*:</h4>
                <input type="text" v-model="source.src" @change="saveVideo('video')" :disabled="!$parent.mediaProperty.isActive"/>
            </div>
            <div class="formRow">
                <h4>Type*:</h4>
                <select v-model="source.type" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive">
                    <option value="video/mp4">MP4</option>
                    <option value="video/ogg">OGG</option>
                </select>
            </div>
            <div class="formRow">
                <h4></h4>
                <UploadMediaPropertyModal openButtonText="Upload Video"
                                            modalTitle="Upload Video"
                                            :fileKey="source.src"
                                            acceptFileTypes=".mp4, .ogg"
                                            :onFileUpload="getVideoLink"
                                            :permission="$parent.mediaProperty.configuration.public ? 'public-read' : 'private'"></UploadMediaPropertyModal>
            </div>
            <button class="deleteButton" @click="deleteVideoSource(index)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
        </div>
        <button class="addRowButton" @click="addVideoSource" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
        <div v-if="videoLink" class="videoPreview">
            <h4>Video Preview</h4>
            <div v-if="$parent.mediaProperty.configuration.sources.length > 1">
                <h4>Select Source</h4>
                <select v-model="activeVideo" @change="getVideoLink">
                    <option v-for="source in $parent.mediaProperty.configuration.sources" :key="source.src" :value="source.order">{{ source.order + 1 }}</option>
                </select>
            </div>
            <video controls :key="videoKey">
                <source :key="videoLink.src" :src="videoLink.src" :type="videoLink.type">
            </video>
            <div>Not to scale</div>
        </div>
        <h4>Captions:</h4>
        <div class="formRow" style="display:flex;flex-direction:column;align-items: start;">
            <button class="primaryButton" @click="generateVTT">Generate VTT from Sonix</button>
            <p v-if="$parent.mediaProperty.configuration.ccFileIsAutoGenerated">**This file has been automatically generated by a transcription service**</p>
        </div>
        <div class="childObject" v-for="(track, index) in $parent.mediaProperty.configuration.tracks" :key="track.key">
            <div class="sequenceButtons" v-if="$parent.mediaProperty.configuration.tracks.length > 1">
                <div class="sequenceMinusButton" @click="sequenceMinus(track, $parent.mediaProperty.configuration.tracks)">
                    <i class="fa-solid fa-angle-up"></i>
                </div>
                <div class="sequencePlusButton" @click="sequencePlus(track, $parent.mediaProperty.configuration.tracks)">
                    <i class="fa-solid fa-angle-down"></i>
                </div>
            </div>
            <div class="formRow">
                <h4>Label*:</h4>
                <input type="text" v-model="track.label" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
            </div>
            <div class="formRow">
                <h4>Language*:</h4>
                <select v-model="track.srclang" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive">
                    <option value="en">English</option>
                    <option value="es">Spanish</option>
                    <option value="pt">Portuguese</option>
                </select>
            </div>
            <div class="formRow">
                <h4>Src*:</h4>
                <input type="text" v-model="track.src" @change="saveVideo" :disabled="!$parent.mediaProperty.isActive"/>
            </div>
            <div class="formRow">
                <h4>Default?</h4>
                <input type="checkbox" v-model="track.default" @change="changeDefaultTrack(track)" :disabled="!$parent.mediaProperty.isActive"/>
            </div>
            <template v-if="track.srclang === 'en' && track.ccFileIsAutoGenerated">
                <div class="formRow">
                    <h4></h4>
                    <p>**This file has been automatically generated by a transcription service**</p>
                </div>
                <div class="formRow" v-if="newestTranscriptionIsUnvalidated">
                    <h4></h4>
                    <div style="display:flex;flex-direction:column;margin-bottom:10px;">
                        <p>This video's transcription is not yet validated</p>
                        <button @click="goToTranscription" class="primaryButton">View Transcription</button>
                    </div>
                </div>
            </template>
            <div class="formRow">
                <h4></h4>
                <a class="primaryButton" :href="track.downloadUrl" target="_blank" :key="ccKey">Download Caption File</a>
            </div>
            <div class="formRow">
                <h4></h4>
                <UploadMediaPropertyModal openButtonText="Upload New Caption File"
                                            modalTitle="Upload Captions"
                                            :fileKey="track.src"
                                            acceptFileTypes=".vtt, .srt"
                                            :permission="$parent.mediaProperty.configuration.public ? 'public-read' : 'private'"
                                            :onFileUpload="onCaptionUpload"></UploadMediaPropertyModal>
            </div>
            <button class="deleteButton" @click="deleteCaption(index)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
        </div>
        <button class="addRowButton" @click="addCaption" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i></button>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {storage} from '../../shared/storage';
import UploadMediaPropertyModal from './UploadMediaPropertyModal.vue';

export default {
    name: 'VideoEdit',
    components: { UploadMediaPropertyModal },
    data() {
        return {
            logActivityTypes: [],
            imageKey: 0,
            imageLink: null,
            activeVideo: 0,
            videoLink: null,
            videoKey: 0,
            ccKey: 0
        }
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return (
                configuration.width &&
                configuration.width > 0 &&
                configuration.height &&
                configuration.height > 0 &&
                configuration.sources.length > 0
            )
        },
        newestTranscriptionIsUnvalidated() {
            return this.$parent.mediaProperty.aiTranscriptions.length && this.newestTranscription.statusCode !== 'Validated';
        },
        newestTranscription() {
            const array = this.$parent.mediaProperty.aiTranscriptions;
            return array.sort((a,b) => a.lastModifiedDateTime - b.lastModifiedDateTime)[0];
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                height: 337,
                width: 600,
                controls: true,
                autoPlay: false,
                public: true,
                loggingActivities: [],
                sources: [],
                tracks: []
            }
        } else {
            let configuration = this.$parent.mediaProperty.configuration;
            if(!configuration.loggingActivities)
                configuration.loggingActivities = [];
            for(let i = 0; i < configuration.loggingActivities.length; i++) {
                configuration.loggingActivities[i].key = i;
            }
            if(!configuration.sources)
                configuration.sources = [];
            for(let i = 0; i < configuration.sources.length; i++) {
                configuration.sources[i].key = i;
                configuration.sources[i].order = i;
            }
            if(!configuration.tracks)
                configuration.tracks = [];
            for(let i = 0; i < configuration.tracks.length; i++) {
                configuration.tracks[i].key = i;
            }
            configuration.tracks.sort((a,b) => {return a.order - b.order});
        }

        this.logActivityTypes = await data.getLogActivityTypes('', true);
        this.logActivityTypes.sort((a,b) => {
            if (a.code > b.code) return 1;
            if (a.code < b.code) return -1;
            return 0;
        });
        if(this.$parent.mediaProperty.configuration.poster)
            await this.getImageLink();
        if(this.$parent.mediaProperty.configuration.sources.length) 
            await this.getVideoLink();
        if(this.$parent.mediaProperty.configuration.tracks.length)
            await this.getCCLinks();
    },
    methods: {
        getLogActivityTypeDescription(logActivityTypeCode) {
            if(this.logActivityTypes.length > 0) {
                return this.logActivityTypes.find(lat => lat.code === logActivityTypeCode).description;
            } else {
                return '';
            }
        },
        async saveVideo(updateSrc) {
             //we don't want to save a blank string here.
            if(this.$parent.mediaProperty.configuration.poster === '') this.$parent.mediaProperty.configuration.poster = null; 

            if(this.validated) {
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
                if(updateSrc === 'poster')
                    this.getImageLink();
                if(updateSrc === 'video') {
                    for(let i = 0; i < this.$parent.mediaProperty.configuration.sources.length; i++) {
                        this.$parent.mediaProperty.configuration.sources[i].key = i;
                        this.$parent.mediaProperty.configuration.sources[i].order = i;
                    }
                    this.getVideoLink();
                }
            }
        },
        changeDefaultTrack(track) {
            if(track.default) {
                for(let i = 0; i < this.$parent.mediaProperty.configuration.tracks.length; i++) {
                    if(this.$parent.mediaProperty.configuration.tracks[i].order !== track.order)
                        this.$parent.mediaProperty.configuration.tracks[i].default = false;
                }
            }
            this.saveVideo();
        },
        sequenceMinus: function(obj, parentArr) {
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].order === (obj.order - 1))
                    parentArr[i].order++;
            }
            if(obj.order > 1)
                obj.order --;
            parentArr.sort((a,b) => {return a.order - b.order;});
            this.saveVideo();
        },
        sequencePlus: function(obj, parentArr) {
            for(let i = 0; i < parentArr.length; i++) {
                if(parentArr[i].order === (obj.order + 1))
                    parentArr[i].order--;
            }
            if(obj.order < parentArr.length)
                obj.order ++;
            parentArr.sort((a,b) => {return a.order - b.order;});
            this.saveVideo();
        },
        addLoggingActivity() {
            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 0,
                logActivityTypeCode: ''
            });
        },
        addDefaultLogging() {
            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 0,
                logActivityTypeCode: 'VIDEO_STARTED'
            });

            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 25,
                logActivityTypeCode: 'VIDEO_25%'
            });

            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 50,
                logActivityTypeCode: 'VIDEO_50%'
            });

            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 75,
                logActivityTypeCode: 'VIDEO_75%'
            });

            this.$parent.mediaProperty.configuration.loggingActivities.push({
                percentage: 100,
                logActivityTypeCode: 'VIDEO_FINISHED'
            });
            this.saveVideo();
        },
        deleteLoggingActivity(index) {
            this.$parent.mediaProperty.configuration.loggingActivities.splice(index, 1);
            this.saveVideo();
        },
        addVideoSource() {
            this.$parent.mediaProperty.configuration.sources.push({
                src: '',
                type: ''
            });
        },
        deleteVideoSource(index) {
            this.$parent.mediaProperty.configuration.sources.splice(index, 1);
            this.saveVideo();
        },
        addCaption() {
            this.$parent.mediaProperty.configuration.tracks.push({
                label: '',
                srclang: '',
                src: '',
                default: false,
                kind: 'captions',
                order: this.$parent.mediaProperty.configuration.tracks.length + 1
            });
        },
        deleteCaption(index) {
            this.$parent.mediaProperty.configuration.tracks.splice(index, 1);
            this.saveVideo();
        },
        onCaptionUpload: function(src) {
            let track = this.$parent.mediaProperty.configuration.tracks.find(tr => tr.src === src);
            if(track)
                track.ccFileIsAutoGenerated = false;
            this.getCCLinks();
        },
        getImageLink: async function() {
            this.imageLink = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.poster, this.$parent.mediaProperty.configuration.public);
            this.imageKey++;
        },
        getVideoLink: async function() {
            const source = this.$parent.mediaProperty.configuration.sources.find(sr => sr.order === parseInt(this.activeVideo));
            if(source) {
                this.videoLink = {
                    src: await storage.getWasabiLink(source.src, this.$parent.mediaProperty.configuration.public),
                    type: source.type
                }
                this.videoKey++;
            }
        },
        getCCLinks: async function() {
            for(let i = 0; i < this.$parent.mediaProperty.configuration.tracks.length; i++) {
                this.$parent.mediaProperty.configuration.tracks[i].downloadUrl = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.tracks[i].src, this.$parent.mediaProperty.configuration.public);
            }
            this.ccKey++;
        },
        changePublic: async function() {
            const config = this.$parent.mediaProperty.configuration;
            const permission = config.public ? 'public-read' : 'private';
            if(config.poster) {
                await storage.updateStoragePermissions(config.poster, permission, null, this.getImageLink);
            }
            if(config.sources.length) {
                for(let i = 0; i < config.sources.length; i++) {
                    await storage.updateStoragePermissions(config.sources[i].src, permission);
                }
                await this.getVideoLink();
            }
            if(config.tracks.length) {
                for(let i = 0; i < config.tracks.length; i++) {
                    await storage.updateStoragePermissions(config.tracks[i].src, permission);
                }
                await this.getCCLinks();
            }
            await this.saveVideo();
        },
        generateVTT: async function() {
            let englishTrack = this.$parent.mediaProperty.configuration.tracks.find(tr => tr.srclang === 'en');
            if(englishTrack)
                if(!confirm('This will submit the video for auto-transcribing even though this video already has a VTT file. Proceed?'))
                    return;
            else
                if(!confirm('This will submit the video for auto-transcribing. Proceed?'))
                    return;
            const response = await data.submitMediaForTranscription(this.$parent.mediaProperty.id, this.videoLink.src, this.$parent.mediaProperty.defaultLanguage);
            if(response.success) {
                this.$toast.success('Video submitted for transcription');
                let src = this.$parent.mediaProperty.configuration.sources.find(sr => sr.order === parseInt(this.activeVideo)).src;
                src = src.replace('/Video/', '/VTTs/');
                if(src.charAt(0) === '/')
                    src = src.substring(1);
                src = src.split('.').splice(0, 1).concat('vtt').join('.');
                if(!englishTrack) {
                    this.$parent.mediaProperty.configuration.tracks.push({
                        label: 'English',
                        srclang: 'en',
                        src: src,
                        default: false,
                        kind: 'captions',
                        order: this.$parent.mediaProperty.configuration.tracks.length + 1,
                        ccFileIsAutoGenerated: true
                    });
                } else {
                    englishTrack.src = src;
                    englishTrack.ccFileIsAutoGenerated = true;
                }
                await this.saveVideo('video');
                this.$parent.mediaProperty.aiTranscriptions = await data.browseAITranscriptionsByMediaPropertyId(this.$parent.mediaProperty.id);
            }
            else if(response.errors)
                this.$toast.error(response.errors.join('<br/>'));
        },
        goToTranscription: function() {
            window.location.href = '/AITranscriptionEdit?ID=' + this.newestTranscription.id;
        }
    }
}
</script>

<style scoped>
    .childObject{
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        padding-left: 100px;
    }

    .sequenceButtons {
        z-index: 10;
        position: absolute;
        top: 20px;
        left: 20px;
    }
    .sequenceMinusButton, .sequencePlusButton {
        cursor: pointer;
    }
    .configuration .deleteButton {
        bottom: 20px;
        right: 20px;
        top:auto;
    }

    .logActivityTypeDescription {
        width: 250px;
    }

    .loggingRow {
        display: flex;
        flex-direction: row;
        border-collapse: 1;
        justify-content: space-between;
        width: 80%;
        border-top: solid 1px;
        border-bottom: solid 1px;
        background-color: rgb(240, 240, 240);
        padding: 5px;
        margin-top: -1px;

    }

    .loggingCell {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1 1;
    }

    .loggingCellSelect {
        flex: 1 1 200px;
    }

    .loggingCell .deleteButton {
        display: flex;
        position: relative;
        padding: 5px;
        bottom: unset;
        top: unset;
        right: unset;
    }
    .videoPreview video {
        max-width: 400px;
        max-height: 200px;
        margin-top: 30px;
    }
    .primaryButton {
        height: 40px;
        width: 180px;
        border-radius: 5px;
        border-color: #036991;
        background-color: #036991;
        color: white;
        cursor: pointer;
        font-size: 16px;
    }
    a.primaryButton {
        text-decoration: none;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        border-bottom: solid 2px black;
        border-right: solid 2px black;
    }
</style>